import { useEffect, useState } from "react"

const useMediaQuery = breakpoint => {
    const [ isMobile, setIsMobile ] = useState(true);

    useEffect(() => {
        if ( window ) {
            const handleResize = () => {
                setIsMobile(window.outerWidth < breakpoint);
            };
            window.addEventListener('resize', handleResize);

            setIsMobile(window.outerWidth < breakpoint);

            return () => {
                window.removeEventListener('resize', handleResize)
            }
        }
    }, [])

    return isMobile;
}

export default useMediaQuery